<template>
  <div>
    <pop-up-message :dynamicWidth="'80%'" popupHeaderMessage="EXEMPT U/S 80C, 80CCC & 80 CCD" v-if="show80cPopup"
      :message="'Qualified Amount : 150000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 500px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>Income Tax Deductions under Section 80C</h3>
              <p>Income tax section 80C replaced section 88 and became effective on 1st April 2006. This section
                provides provisions for a number of payments. The eligible taxpayers can claim deductions of the maximum
                amount up to Rs. 1.5 lakh per year. Both individuals and HUFs are eligible for income tax deductions
                under 80C.</p>
              <p>This section includes the following investments and expenses:</p>

              <ul>
                <li><strong>Investment in PPF:</strong> You can claim a deduction for the investment made in the PPF
                  account. You can invest a maximum of Rs. 1.5 lakh in a year. Receipts on maturity and withdrawal are
                  tax-free.</li>
                <li><strong>Investment in National Savings Certificate:</strong> National Savings Certificates are
                  eligible for deductions in the year they are purchased. Interest accrued on such certificates is
                  eligible for tax deductions each year under section 80C but becomes taxable at the time of maturity.
                </li>
                <li><strong>Investment in Fixed Deposit:</strong> Interest earned on fixed deposits with tenure of not
                  less than five years is eligible for tax deduction under section 80C. For senior citizens, tax-exempt
                  interest income on deposits with banks has been increased from Rs. 10,000 to Rs. 50,000. Further, TDS
                  will not be required to be deducted under section 194A and it has been extended to all FD and RD
                  schemes.</li>
                <li><strong>Premium on Life Insurance Policy:</strong> You can claim a deduction under section 80C for
                  the premium paid for a life insurance policy as per the Income Tax Act.</li>
                <li><strong>Contribution to Employee Provident Fund:</strong> You can claim a tax deduction for the
                  contribution made in the employee provident fund under section 80C. Government to contribute 12% of
                  EPF contribution for new employees (with less than 3 years of employment) in all sectors. New women
                  employees (with less than 3 years of employment) to contribute only 8% of their salary as EPF
                  contribution as opposed to 12% earlier.</li>
                <li><strong>Equity-Oriented Mutual Funds:</strong> You can claim a tax deduction for investment made in
                  any unit of mutual funds whether it is listed on a stock exchange or not.</li>
                <li><strong>Repayment of Principal on Housing Loan:</strong> You can claim a tax deduction on the
                  principal amount paid for the home loan under section 80C.</li>
                <li><strong>Tuition Fees:</strong> You can claim a tax deduction for the tuition fees paid under section
                  80C. However, the deduction will only be applicable in case the fees are paid by cheque.</li>
              </ul>

              <h3>Tax Deductions under Section 80CCC and 80CCD for Contributions to Pension Funds</h3>
              <p>You can claim a tax deduction under Section 80CCC and 80CCD for the contribution made to Pension Funds.
                If you have contributed any amount in any insurance scheme to receive a pension, then you can claim a
                tax deduction under 80CCC. However, if you have contributed to any pension scheme initiated by the
                central government, up to 10% of your salary such as the National Pension Scheme then you can claim a
                tax deduction under section 80CCD.</p>

              <p><strong>Note:</strong> As per the Income Tax Act, the maximum limit of Rs. 1.5 lakh is an aggregate of
                deduction that may be claimed under sections 80C, 80CCC, and 80CCD. However, an exclusive tax benefit is
                available for NPS subscribers under section 80CCD. As per the Income Tax Act, Tier 1 account holders get
                an additional deduction for investments up to Rs. 50,000 in NPS. This deduction is over and above the
                deduction of Rs. 1.5 lakh available under section 80C of the IT Act, 1961.</p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="show80cPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message>
    <pop-up-message :dynamicWidth="'60%'" popupHeaderMessage="80DD - Medical Expenditure for a Handicapped Relative" v-if="show80DDPopup"
      :message="'Qualified Amount : 125000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 500px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>MEDICAL TREATMENT / INSURANCE OF HANDICAPPED DEPENDENT - 80DD</h3>
              <p>To be eligible for the claim deduction under section 80DD, one must:</p>
              <ol>
                <li>Be an Individual or be a part of a Hindu undivided family, who is a resident in India.</li>
                <li>This deduction is not available to non-resident Indians (NRI), since a lot of countries such as
                  Canada, largely help their residents when it comes to medical treatment.</li>
              </ol>

              <h3>Expenses that are Deducted for Income Tax Calculation:</h3>
              <p>The following are the expenses that are exempted from income tax under section 80DD:</p>
              <ul>
                <li>Any expenses incurred for medical treatment, which includes nursing, training, and rehabilitation of
                  a disabled dependent.</li>
                <li>The amount paid towards Life Insurance Corporation (LIC), Unit Trust of India or any of the other
                  insurers for the sole purpose of buying specified schemes or insurance policies to help in the
                  maintenance of a dependent with disabilities.</li>
              </ul>

              <h3>Who is Defined as a Disabled Dependant According to Income Tax Laws?</h3>
              <p>If a person falls under the following circumstances, he or she is eligible to be called a disabled
                dependent under section 80DD, and hence the person’s caretaker can avail of the income deductions:</p>
              <ul>
                <li>Individuals, or a spouse, son or daughter (or any child), parents as well as brother or sister i.e.
                  any siblings can be considered as your disabled dependant.</li>
                <li>This is applicable for any Hindu undivided Family, which means that any member of the HUF can be a
                  disabled dependent.</li>
                <li>It is essential that the disabled individual be wholly or mostly dependent on the taxpayer for their
                  support as well as maintenance.</li>
                <li>He or she should also not claim the deduction under section 80U.</li>
                <br>
                <br>
                <li><strong>To claim this section, the employee must submit Form 10I or Form 10IA</strong></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="show80DDPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message>
    <pop-up-message
      :dynamicWidth="'40%'"
      popupHeaderMessage="80DDB - Medical Expenditure on Self or Dependent Relative for Treating Severe Diseases"
      v-if="show80DDBPopup" :message="'Qualified Amount : 100000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 500px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <p>Section 80DDB speaks of deductions in respect of expenses incurred for medical treatment of specified
                diseases or ailments.
                Section 80DDB provides that where an individual or a HUF has incurred medical expenses for treatment of
                a specified disease or ailment such expense is allowed as a deduction, subject to such conditions and
                capped at such amount as specified, under Section 80DDB of Income Tax Act.
                Here, the section speaks of medical expenses incurred on treatment of specified diseases or ailments and
                should not be confused with premium paid for health insurance bought covering such diseases or ailments.
                The payment for health insurance is covered under Section 80D of the Income Tax Act.
              </p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="show80DDBPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message>
    <pop-up-message :dynamicWidth="'60%'" popupHeaderMessage="80U - Medical Expenditure on Self in Case of Physical Disability"
      v-if="show80UPopup" :message="'Qualified Amount : 125000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>PERMANENT PHYSICAL DISABILITY - 80U</h3>

              <h4>Eligibility</h4>
              <p>The tax benefit is available to any resident individual who is certified as “a person with a
                disability” by the “medical authority”.</p>

              <h4>Deduction limit</h4>
              <p>For deduction under section 80U, individuals or persons with disability are categorized into two types:
              </p>

              <ol>
                <li><strong>Person with disability:</strong> A person with disability means the person is suffering from
                  at least 40% of a disability. If an individual has at least 40% of a disability, then he is eligible
                  for a deduction of Rs. 75,000.</li>
                <li><strong>Person with severe disability:</strong> A person with a disability is a person who is
                  suffering from at least 80% of a disability. If an individual has a severe disability (i.e., 80% or
                  more of a disability), then he is eligible for a deduction of Rs. 1,25,000.</li>
                  <br>
                  <br>
                <li><strong>To claim this section, the employee must submit Form 10I or Form 10IA.
                </strong></li>
              </ol>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="show80UPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message>
    <pop-up-message :dynamicWidth="'50%'" popupHeaderMessage="80 G - Donation towards exempted Social Causes" v-if="show80GPopup"
      :message="'Qualified Amount : No Limit'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>Section 80G</h3>
              <ul>
                <li>Only donations made to prescribed relief funds, charitable institutions, can be claimed as a
                  deduction under section 80G.</li>
                <li>Any taxpayer, whether resident or non-resident, can claim deductions under section 80G.</li>
                <li>
                  The mode of payment can be <strong>Cash, Cheque, or Draft</strong>. However, donations made through
                  cash can be claimed up to Rs. 2,000/- (F.Y. 2017-18 onwards).
                </li>
                <li>Donations made in kind (e.g., food, clothes, medicine, etc.) don’t qualify for any deduction under
                  this section.</li>
                <li>
                  To claim the deduction, the donor has to furnish the receipt as proof of payment. The receipt should
                  include:
                  <ul>
                    <li>Name, address, PAN, and the registration number of the trust given by the Income Tax Department
                      u/s 80G along with its validity</li>
                    <li>Amount donated</li>
                    <li>Name of the donor</li>
                  </ul>
                </li>
                <li>
                  In case of donations that have a limit of 10% of the Adjusted Gross Total Income, the amount is
                  calculated by:
                  <ul>
                    <li>Taking the sum of income under all heads (gross total income)</li>
                    <li>Reducing it by the aggregate of:
                      <ul>
                        <li>Deductions u/s 80CCC to 80U except for Section 80G</li>
                        <li>Exempt income</li>
                        <li>Long-term capital gains</li>
                        <li>Income referred to in Sections 115A, 115AB, 115AC, 115AD, and 115D, relating to
                          non-residents and foreign companies</li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  Exemption parameters:
                  <ul>
                    <li>Donations towards Social Causes (Full amount will be exempted)</li>
                    <li>Donations towards Private entities with:
                      <ul>
                        <li>100% exemption</li>
                        <li>50% exemption (Minimum of Declared Amount or 10% of Adjusted Gross Total Income will be
                          exempted)</li>
                      </ul>
                    </li>
                    <li>Donations towards Private entities with:
                      <ul>
                        <li>100% exemption Unrestricted</li>
                        <li>50% exemption Unrestricted (Full amount will be exempted)</li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="show80GPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message>
    <pop-up-message :dynamicWidth="'80%'" popupHeaderMessage="Section 24 - Interest paid on Housing Loan for a Self-Occupied Property" v-if="showSec24SOPPopup"
      :message="'Qualified Amount : 200000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 500px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h4 style="margin-bottom: 10px; color: #34495e;">Tax Benefits on Home Loan</h4>
        <p>The below details describe the tax benefits on the Home loan as applicable for the current Financial Year:</p>

        <h4 style="margin: 10px 0; color: #2c3e50;">First Home – Self Occupied</h4>
        <ul style="margin: 10px 0; padding-left: 20px;">
          <li style="margin-bottom: 10px;">
            <strong>On Principal Repaid:</strong> Actual principal repaid subject to a maximum of Rs. 1,50,000 (Rs. 2 lakh for senior citizens) 
            can be claimed as investment eligible for tax deduction under section 80C.
          </li>
          <li style="margin-bottom: 10px;">
            <strong>On Interest Paid:</strong> Actual home loan interest paid subject to a maximum of Rs. 2 lakh (Rs. 3 lakh for senior citizens) 
            if house construction is completed within 5 years from the end of the financial year in which the loan is taken. If the construction of the house 
            is not completed within five years, then Rs. 30,000 is tax exempt.
          </li>
          <li style="margin-bottom: 10px;">
            <strong>Additional Exemption:</strong> Up to Rs. 50,000 on interest paid for loans up to Rs. 35 lakh with a cost of the home up to Rs. 50 lakh.
          </li>
        </ul>

        <h4 style="margin: 10px 0; color: #2c3e50;">First Home – Rented/ Vacant (Deemed to Be Let Out Property)</h4>
        <ul style="margin: 10px 0; padding-left: 20px;">
          <li style="margin-bottom: 10px;">
            <strong>On Principal Repaid:</strong> Up to Rs. 1,50,000 (Rs. 2 lakh for senior citizens) eligible for tax deduction under Section 80C. 
            The deduction is available only if the property owner is staying in a different city for work.
          </li>
          <li style="margin-bottom: 10px;">
            <strong>On Interest Paid:</strong> Exemption on interest is capped at the lower of two: 
            a) Rs. 2,00,000 or b) actual interest paid for all properties owned by a taxpayer.
          </li>
        </ul>

        <h4 style="margin: 10px 0; color: #2c3e50;">Second Home or Additional Property</h4>
        <ul style="margin: 10px 0; padding-left: 20px;">
          <li style="margin-bottom: 10px;">
            <strong>On Principal Repaid:</strong> None
          </li>
          <li style="margin-bottom: 10px;">
            <strong>On Interest Paid:</strong> Exemption on interest is capped at the lower of two: 
            a) Rs. 2,00,000 or b) actual interest paid for all properties owned by a taxpayer.
          </li>
        </ul>

        <h4 style="margin: 10px 0; color: #2c3e50;">Under Construction Property</h4>
        <ul style="margin: 10px 0; padding-left: 20px;">
          <li style="margin-bottom: 10px;">
            <strong>On Principal Repaid:</strong> None
          </li>
          <li style="margin-bottom: 10px;">
            <strong>On Interest Paid:</strong> The interest paid can be claimed in equal parts over five financial years after 
            the completion or handing over of property within the overall annual limit of Rs. 2 lakh.
          </li>
        </ul>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showSec24SOPPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message>
    <pop-up-message :dynamicWidth="'80%'" popupHeaderMessage="Section 24 - Interest paid on Housing Loan for a let-out Property" v-if="showSec24LOPPopup"
      :message="'Qualified Amount : 200000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 510px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3 style="color: #34495e; margin-bottom: 10px;">Home Loan Tax Benefits</h3>
        <p>The details below describe the home loan's tax benefits as applicable to the current financial year:</p>

        <h4 style="margin: 10px 0; color: #2c3e50;">First Home – Self Occupied</h4>
        <ul style="padding-left: 20px; margin: 10px 0;">
          <li style="margin-bottom: 10px;">
            <strong>On Principal Repaid:</strong> Actual principal repaid subject to a maximum of Rs. 1,50,000 (Rs. 2 lakh for senior citizens) 
            can be claimed as investment eligible for tax deduction under section 80C.
          </li>
          <li style="margin-bottom: 10px;">
            <strong>On Interest Paid:</strong> Actual home loan interest paid subject to a maximum of Rs. 2 lakh (Rs. 3 lakh for senior citizens) 
            if house construction is completed within 5 years from the end of the financial year in which the loan is taken.
          </li>
          <li style="margin-bottom: 10px;">
            <strong>If Construction is Delayed:</strong> If the construction of the house is not completed within five years, then Rs. 30,000 is tax exempt.
          </li>
          <li style="margin-bottom: 10px;">
            <strong>Additional Exemption:</strong> Up to Rs. 50,000 on interest paid for loans up to Rs. 35 lakh with a cost of the home up to Rs. 50 lakh.
          </li>
        </ul>

        <h4 style="margin: 10px 0; color: #2c3e50;">First Home – Rented/ Vacant (Deemed to Be Let Out Property)</h4>
        <ul style="padding-left: 20px; margin: 10px 0;">
          <li style="margin-bottom: 10px;">
            <strong>On Principal Repaid:</strong> Up to Rs. 1,50,000 (Rs. 2 lakh for senior citizens) eligible for tax deduction under Section 80C. 
            The deduction is available only if the property owner is staying in a different city for work.
          </li>
          <li style="margin-bottom: 10px;">
            <strong>On Interest Paid:</strong> Exemption on interest is capped at the lower of two: 
            a) Rs. 2,00,000 or b) actual interest paid for all properties owned by a taxpayer.
          </li>
        </ul>

        <h4 style="margin: 10px 0; color: #2c3e50;">Second Home or Additional Property</h4>
        <ul style="padding-left: 20px; margin: 10px 0;">
          <li style="margin-bottom: 10px;">
            <strong>On Principal Repaid:</strong> None
          </li>
          <li style="margin-bottom: 10px;">
            <strong>On Interest Paid:</strong> Exemption on interest is capped at the lower of two: 
            a) Rs. 2,00,000 or b) actual interest paid for all properties owned by a taxpayer.
          </li>
        </ul>

        <h4 style="margin: 10px 0; color: #2c3e50;">Under Construction Property</h4>
        <ul style="padding-left: 20px; margin: 10px 0;">
          <li style="margin-bottom: 10px;">
            <strong>On Principal Repaid:</strong> None
          </li>
          <li style="margin-bottom: 10px;">
            <strong>On Interest Paid:</strong> The interest paid can be claimed in equal parts over five financial years 
            post-completion or handing over of property within the overall annual limit of Rs. 2 lakh.
          </li>
        </ul>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showSec24LOPPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message>
    <table>
      <thead>
        <tr class="header-row">
          <th v-for="(columnHeaderData, index) in tableColumsHeader" :key="index"
            :style="columnHeaderData.style ? columnHeaderData.style : ''">
            {{ columnHeaderData.label }}
            <span
              v-if="columnHeaderData.key === '80DDBparticulars'||columnHeaderData.key === '80Cparticulars'||columnHeaderData.key === '80DDparticulars'||columnHeaderData.key === '80Gparticulars'||columnHeaderData.key === '80Uparticulars'||columnHeaderData.key === 'interestOnHousingLoan'||columnHeaderData.key==='income/lossOnHouse'">
              <img src="@/assets/info-black.svg" alt="Info"
                style="cursor: pointer; margin-left: 5px; vertical-align: middle;"
                @click="showpopup(columnHeaderData.key)" />
            </span>
            <span v-else>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="body-row" v-for="(columnData, DataIndex) in tableColumnsData" :key="DataIndex">
          <td v-for="(columnHead, index) in tableColumsHeader" :key="index"
            :style="columnHead.style ? columnHead.style : ''">
            <slot :value="{
                record: columnData,
                column: columnHead,
                index: DataIndex,
              }"></slot>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</template>
<script>
export default {
  props: {
    tableColumsHeader: Array,
    tableColumnsData: Array,
  },
  data() {
    return {
      show80cPopup: false,
      show80DDPopup: false,
      show80DDBPopup: false,
      show80UPopup: false,
      show80GPopup: false,
      showSec24SOPPopup: false,
      showSec24LOPPopup: false,
    };
  },
  mounted() {},
  updated() {},
  created() {},
  methods:{
    showpopup(key){
    
    if(key=='80Cparticulars'){
      this.show80cPopup = true
    }
    else if(key=='80DDparticulars'){
      this.show80DDPopup = true
    }
    else if(key=='80DDBparticulars'){
      this.show80DDBPopup = true
    }
    else if(key=='80Uparticulars'){
      this.show80UPopup = true
    }  
    else if(key=='80Gparticulars'){
      this.show80GPopup = true
    }  
    else if(key=='interestOnHousingLoan'){
      this.showSec24SOPPopup = true
    } 
    else if(key=='income/lossOnHouse'){
      this.showSec24LOPPopup = true
    } 
    
  }
  },
  
};
</script>
<style lang="scss">
table {
  width: 100%;
  box-sizing: border-box;
}
.header-row {
  background-color: white;
  height: 54px;
  th {
    background-color: #dcdfdf;
    border-bottom: 1px solid #34c0be;
    padding: 6px 30px;
  }
}
.btn-popup-cancel {
  display: block;
  border-radius: 4px;
  min-width: 150px;
  padding: 0px 10px;
  height: 35px;
  background-color: #ffffff;
  border: #5D409F solid 2px;
  color: #5D409F;
}
table {
  border-collapse: collapse;
}
.body-row:hover {
  &:nth-child(odd) {
    background-color: #dceaec;
  }
}
.body-row {
  background-color: white;
  &:nth-child(even) {
    background-color: #f0f1f5;
  }
  td {
    border-bottom: 1px solid rgb(217, 212, 212);
    padding: 15px 30px;
  }
}
</style>
